<template>
	<div
		class="menu-groups"
		:style="menuStyle"
		v-show="(visible && hasGroups) || hasNoMatches"
	>
	<div class="menu-groups__groups">
		<div
			class="menu-groups__group"
			v-for="group in groups"
			:key="group.name"
		>
			<h3 class="menu-groups__group-label">{{ group.name }}</h3>
			<ul class="menu-groups__items">
				<!-- DEV NOTE: This needs to apply the "is-active" class when an item is selected-->
				<DropdownMenuItem
					v-for="option in group.options"
					:key="option.value"
					:text="option.text"
					:value="option.value"
					:iconClass="option.iconClass"
					:disabled="option.disabled"
					@itemClick="onSelect"
					:defaultItemClass="menuItemClass"
				/>
				<div class="menu-groups__no-matches" v-if="hasNoMatches">
					<span>No matches found</span>
				</div>
			</ul>
		</div>
	</div>
</div>
</template>

<script>
import baseComponentMixin from '@/mixins/base-component-mixin';
import DropdownMenuItem from './menu-dropdown-item.vue';

export default {
	name: 'MenuGroups',
	mixins: [baseComponentMixin],
	components: {
		DropdownMenuItem
	},
	data() {
		return {
			menuItemClass: 'menu-groups__item',
			selectedDropdownValue: undefined,
			selection: {}
		};
	},
	props: {
		/**
		 * A menu option.
		 * @typedef {Object} Option
		 * @property {String} text
		 * @property {String|Number} value
		 * @property {String} iconClass
		 * @property {boolean} disabled
		 */

		/**
		 * @type Array
		 */
		groups: {
			type: Array,
			default: () => []
		},
		value: {
			type: Object
		},
		visible: {
			type: Boolean,
			default: false
		},
		hasNoMatches: {
			type: Boolean,
			default: false
		},
		minWidth: {
			type: String,
			default: 'auto'
		}
	},
	methods: {
		onSelect(option) {
			this.selected = option.value;

			this.$emit('input', option);
			this.$emit('change', option);
		}
	},
	computed: {
		hasGroups() {
			return this.groups && this.groups.length > 0;
		},
		menuStyle() {
			return {
				minWidth: this.minWidth
			};
		}
	}
};
</script>

<style lang="scss" scoped>
@include scrollbar('borderless');
.menu-groups {
	@include menu-styles;

	&__groups{
		margin: $gutter-md 0;
	}
	&__group {
		&:not(:first-child)
		{
			margin-top: $gutter-md;
		}		
	}

	&__group-label {
		@include heading('sm');
		padding: $padding-xs $padding-md;
		position: sticky;
		top: 0;
		background-color: var(--bg-0);
	}

	&__item {
		padding-left: $padding-lg;
	}
}
.dropdown-group{
	.menu-groups{
		&__groups{
			margin: 0;
		}

		&__group-label {
		padding: $padding-xs $padding-sm;
		}

		&__item {
		padding-left: $padding-md;
	}

	}
}
</style>
